import { Box, Button, Container, Paper, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { Footer } from '@/components/Footer'
import { PublicHeader } from '@/components/PublicHeader'

/**
 * The public home page.
 *
 * Exists because `/` used to sit behind the auth guard, so a signed-out
 * visitor was bounced to /signin and never saw a word about what this is.
 * Google's OAuth verification failed it on exactly that, twice over: the home
 * page was behind a login, and it did not say what the app was for.
 *
 * Deliberately short. Somebody who lands here has either been sent a link by
 * a friend or is a reviewer checking that we are what we claim to be, and
 * both are served by three sentences rather than a pitch. The Footer carries
 * the operator name, the policies and the "we never handle your money" line,
 * so none of that needs repeating here.
 */
export function Landing() {
  return (
    <Box sx={{ minHeight: '100dvh', bgcolor: 'background.default', py: 4 }}>
      <Container maxWidth="sm">
        <PublicHeader />

        <Paper sx={{ p: { xs: 2.5, sm: 4 }, mt: 2 }}>
          <Typography variant="h1" sx={{ fontSize: '1.75rem', mb: 1.5 }}>
            Get paid back.
          </Typography>

          <Typography sx={{ fontSize: '1rem', lineHeight: 1.65, mb: 1.5 }}>
            You paid for something the whole group shared — the rental, the
            tickets, dinner. Fronted works out what each person owes, sends
            them their share, and stops asking once they have paid.
          </Typography>

          <Typography
            sx={{ fontSize: '1rem', lineHeight: 1.65, color: 'text.secondary' }}
          >
            People pay you however they already do. Fronted keeps track and
            does the chasing, so you do not have to keep bringing it up.
          </Typography>

          <Button
            component={RouterLink}
            to="/signin"
            variant="contained"
            size="large"
            sx={{ mt: 3, minHeight: 44 }}
          >
            Sign in
          </Button>
        </Paper>

        <Footer />
      </Container>
    </Box>
  )
}
